import React from "react";
import {FeedbackRating} from "../../../../../api/generated";
import styles from "./FeedbackTable.module.css";

export const FeedbackRatingChip: React.FC<{ rating: FeedbackRating }> = ({rating}) => {
    const isPositive = rating === FeedbackRating.Positive;
    return <span className={isPositive ? styles.positiveChip : styles.negativeChip}>
        <span aria-hidden>{isPositive ? "👍" : "👎"}</span>
        {isPositive ? "Helpful" : "Not helpful"}
    </span>
}

export const SurveyScoreChip: React.FC<{ rating: number }> = ({rating}) => {
    const className = rating <= 2 ? styles.negativeChip : rating === 3 ? styles.mixedChip : styles.positiveChip;
    return <span className={className}>{rating} / 5</span>
}
